export enum StudentActivityType {
  EXAM_CONTENT = 'EXAM_CONTENT',
  BADGE = 'BADGE',
  VICTORY = 'VICTORY',
  PROGRESS = 'PROGRESS',
}
